import { Typography, TypographyProps } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

type LabelLargeProps = TypographyProps;

export const LabelLarge = ({ sx, children, ...props }: LabelLargeProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <Typography
      sx={{
        color: colors.surface.onSurfaceVariant,
        fontSize: "0.875rem",
        lineHeight: "1.25rem",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Typography>
  );
};
